import React from "react";
import { Header } from "./Header";
import { Navigation } from "./Navigation";
import { UserProfile } from "./ui/user-profile";

export const Layout = ({ children }) => {
    return (
        <div className="min-h-screen wave-bg">
            {/* Enhanced Header */}
            <header className="bg-card/98 backdrop-blur-lg border-b border-border/40 shadow-md fixed top-0 left-0 right-0 z-50 transition-all duration-200">
                <div className="w-full px-6">
                    <div className="flex items-center justify-between h-16">
                        <div className="flex items-center space-x-4">
                            <Header />
                        </div>
                        <UserProfile />
                    </div>
                </div>
            </header>

            {/* Fixed Sidebar */}
            <aside className="fixed left-0 top-16 h-[calc(100vh-4rem)] w-80 z-40 overflow-y-auto" style={{
                scrollbarWidth: 'thin',
                scrollbarColor: 'rgba(0,0,0,0.1) transparent'
            }}>
                <div className="p-6 space-y-6 animate-slide-up" style={{ animationDelay: '200ms' }}>
                    <Navigation />
                </div>
            </aside>

            {/* Main Content Area */}
            <div className="fixed top-16 h-[calc(100vh-4rem)] pt-8 pb-20 overflow-y-auto" style={{
                left: '20rem',
                width: 'calc(100vw - 20rem)',
                scrollbarWidth: 'thin',
                scrollbarColor: 'rgba(0,0,0,0.1) transparent'
            }}>
                <main className="animate-fade-in">
                    <div className="px-4">
                        {/* Main Content - render children instead of Outlet */}
                        <div className="space-y-6 animate-slide-up" style={{ animationDelay: '400ms' }}>
                            <div className="space-y-6">
                                {children}
                            </div>
                        </div>
                    </div>
                </main>
            </div>
        </div>
    )
}